import styled from "styled-components";

const StyledModal = styled.div`
  padding: 20px;
  background: #000639;
  border-radius: 5px;
  min-width: 200px;
  min-height: 100px;
  margin: 1rem;
  position: relative;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  justify-self: center;
  display: flex;
  flex-direction: column;
`;

export default StyledModal;
